export * from './main/local-storage.service';
export * from './user-storage.service';
export * from './beneficiaire-storage.service';
export * from './ce-storage.service';



// WEBPACK FOOTER //
// ./src/shared/services/storage/index.ts